import {Component, EventEmitter, forwardRef, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';

@Component({
  selector: 'app-substring',
  templateUrl: './substring.component.html',
  styleUrls: ['./substring.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => SubstringComponent),
      multi: true
    }
  ]
})

export class SubstringComponent implements OnInit, ControlValueAccessor {

  public form: FormGroup;
  @Output() validSuccess = new EventEmitter<any>();
  public  propagateChange = (_: any) => {};

  constructor(private fb: FormBuilder) {
    this.createForm();
  }

  ngOnInit() {
  }

  /**
   * @Metodo createForm
   * @description Crea el formulario y escucha sus cambios
   * */
  createForm() {
    this.form = this.fb.group({
      startIndex: ['', Validators.required],
      length: ['', Validators.required]
    });
    this.form.valueChanges.subscribe(val => {
      this.propagateChange(val);
      this.validFormSubstring();
    });
  }

  /**
   * @Metodo validFormSubstring
   * @description Emite la valides del form
   * */
  validFormSubstring() {
    this.validSuccess.emit(this.form.valid);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState(isDisabled: boolean): void {
  }
  writeValue(obj: any): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/substring/substring.component.ts